import Router from "next/router";
import log from "./logger";
import { withErrorBoundary } from "@lululemon/mwa-logger";

const onError = (
  error = new Error("Unknown error"),
  errorInfo = {},
  componentName = "UnknownComponent",
  shouldRedirect = false
) => {
  const errorLogContext = {
    error: {
      message: `Error in component: ${componentName}`,
      stack: error.stack || "No stack trace available",
    },
    errorInfo: {
      componentStack: errorInfo.componentStack || "No component stack trace",
    },
    componentData: error.componentData || {},
  };

  const fingerprint = `${componentName}-${error.message}`;

  log.error(
    error,
    {
      tags: {
        componentName,
        functionName: "withErrorBoundary",
        featureName: `withErrorBoundary.${componentName}`,
        errorType: "React Error",
        errorMessage: error.message || "No error message",
      },
    },
    (scope) => {
      scope.setContext("error", errorLogContext.error);
      scope.setContext("errorInfo", errorLogContext.errorInfo);
      scope.setContext("componentData", errorLogContext.componentData);
      scope.setFingerprint([fingerprint]);
    }
  );

  if (shouldRedirect) {
    Router.replace(`/error/500?component=${encodeURIComponent(componentName)}`);
  }
};

export const createErrorBoundaryWrapper = (
  Component,
  componentName,
  shouldRedirect = false
) => {
  return withErrorBoundary(Component, {
    onError: (error, errorInfo) =>
      onError(error, errorInfo, componentName, shouldRedirect),
    fallback: null,
  });
};
